export default {
  tag1: {
    title: `Full-chain Supply Chain for Energy Storage Projects`,
    text: `Upstream battery cells | Self-developed midstream PCS & BMS | Energy storage cabins | One-stop supporting services for industrial, commercial and grid energy storage`,
  },
  tag2: {
    title: `Full-Link Supply Chain for Power Battery`,
    text: `Supporting battery cells, modules & battery packs | Integrated supply of energy storage batteries | Full-site delivery for energy storage power stations`,
  },
  tag3: {
    title: `Energy Storage + Charging Dual Closed-Loop Supply Chain`,
    text: `Integrated energy storage & charging supporting｜Cost reduction via large-scale production｜Global warehousing & logistics｜Stable delivery for bulk projects`,
  },
  centerDataImg: require('@/assets/images/cc/tk_en.gif'),
};
